import styled from 'styled-components';

export const FixedContainer = styled.div`
  @media ${(props) => props.theme.device.mobileL} {
    padding: 0 16px;
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 24px;

  @media ${(props) => props.theme.device.tabletL} {
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;

export const Sorting = styled.div`
  margin-bottom: 36px;
`;

export const Legend = styled.div`
  display: grid;
  grid-template-columns: 40% 1fr 1fr 1fr 1fr;
  gap: 10px;
  text-transform: uppercase;
  padding: 0 24px 0 32px;
  width: calc(100% - 20px);
  margin: 0 auto 24px;
`;

export const ScormCard = styled(Legend)`
  text-transform: unset;
  margin-bottom: 8px;
  padding: 24px;
  padding-left: 32px;
  border-radius: 4px;
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
  cursor: pointer;

  &.active {
    background-color: ${(props) => props.theme.colors.bgBox};
  }

  @media ${(props) => props.theme.device.mobileL} {
    grid-template-columns: 100px 1fr;
    gap: 8px;
    padding: 16px;
    margin: 0;
    margin-left: -16px;
    width: var(--full-width);
    box-shadow: none;
    border-bottom: 1px solid ${(props) => props.theme.colors.border};

    > *:nth-child(even) {
      text-align: right;
    }
  }
`;

export const PaginationWrapper = styled.div`
  padding-top: 30px;
  padding-bottom: 30px;

  > div {
    padding-bottom: 0;
  }
`;
